import DocumentCreationButton from 'Components/DocumentCreationButton';
import DocumentHeader from 'Components/DocumentHeader';
import DocumentWrapper from 'Components/DocumentWrapper';
import HistorySection from 'Components/HistorySection';
import FormEditingHandler from 'Containers/FormEditingHandler';
import { dbs } from 'neuro-schemas';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import HistoryRowData from '../../Dbs/Document/HistoryRowData';
import DBSForm from './Form';

const {
  utils: { findActive, findEnded },
} = dbs;

const History = ({ documents, startEdit, setAnchor }: IHistory): React.JSX.Element => {
  return (
    <React.Fragment>
      {findActive(documents).length > 0 ? (
        <HistorySection headerText={<FormattedMessage id="dbs.dbsActive" />} hasHistoryRows={true}>
          {findActive(documents).map((d, i) => (
            <div key={'dbs' + i}>
              <HistoryRowData d={d} startEdit={startEdit} setAnchor={setAnchor} />
            </div>
          ))}
        </HistorySection>
      ) : null}
      {findEnded(documents).length > 0 ? (
        <HistorySection headerText={<FormattedMessage id="dbs.dbsEnded" />} inactive={true} hasHistoryRows={true}>
          {findEnded(documents).map((d, i) => (
            <div key={'dbs' + i}>
              <HistoryRowData d={d} startEdit={startEdit} setAnchor={setAnchor} />
            </div>
          ))}
        </HistorySection>
      ) : null}
    </React.Fragment>
  );
};

interface IHistory {
  documents: IDocumentWithTypeV2<'dbs'>[];
  startEdit: StartEdit;
  setAnchor: (anchor?: string) => () => void;
}

const DBS = ({ documents }: IOwnProps): React.JSX.Element => {
  // Anchor for scrolling to specific form sections in form
  const [anchor, setAnchor] = React.useState<string | undefined>(undefined);
  const setAnchorValue = (anchor?: string) => (): void => {
    setAnchor(anchor);
  };

  return (
    <FormEditingHandler name="dbs" documents={documents}>
      {(editing, startEdit, formData): React.JSX.Element => (
        <DocumentWrapper>
          <DocumentHeader
            name={'dbs'}
            headerId={'dbs.title'}
            editing={editing}
            editButtons={
              documents.length > 0 && findEnded(documents).length < documents.length ? (
                <div>&nbsp;</div>
              ) : (
                <div>
                  <DocumentCreationButton name="dbs" text={'general.new'} onClick={startEdit({})} />
                </div>
              )
            }
          />
          {editing ? <DBSForm editing={editing} formData={formData} anchor={anchor} /> : undefined}
          {!editing ? <History documents={documents} startEdit={startEdit} setAnchor={setAnchorValue} /> : null}
        </DocumentWrapper>
      )}
    </FormEditingHandler>
  );
};

interface IOwnProps {
  documents: IDocumentWithTypeV2<'dbs'>[];
}

export default DBS;
